import ReviewStudentsListItem from './review-students-list-item'

export default ReviewStudentsListItem
